import React from 'react'
import styled from 'styled-components'

import { Modal, Fonts } from 'components/base-ui'
import { useTranslation } from 'react-i18next'

const ModalKPlusPhoneError = ({ ...rest }) => {
  const { t } = useTranslation()
  return (
    <Modal hideCloseButton={false} {...rest}>
      <ModalContainer>
        <Fonts.H2 style={{ marginBottom: '14px' }}>{t('modalKPaymentProcessingErrorTitle')}</Fonts.H2>
        <Fonts.Base style={{ marginBottom: '18px' }}>{t('modalKPaymentProcessingErrorDes')}</Fonts.Base>
      </ModalContainer>
    </Modal>
  )
}

export default ModalKPlusPhoneError

const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding-top: 30px;
`
